export const RESOURCE_ROLES = ['none', 'viewer', 'commenter', 'editor', 'manager'] as const;
export type ResourceRole = (typeof RESOURCE_ROLES)[number];

const rank = (role: ResourceRole): number => RESOURCE_ROLES.indexOf(role);

export function roleAtLeast(actual: ResourceRole, required: ResourceRole): boolean {
  return rank(actual) >= rank(required);
}

export function maxRole(...roles: ResourceRole[]): ResourceRole {
  return roles.reduce<ResourceRole>((best, r) => (rank(r) > rank(best) ? r : best), 'none');
}
